import Vue from 'vue'
import Vuex from 'vuex'
import userInfo from './userInfo'
import utils from './utils'
import order from './order'
import websocket from './websocket'
import tagsView from './tagsView'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: [
    userInfo,
    utils,
    order,
    websocket,
    tagsView
  ]
})


// WEBPACK FOOTER //
// ./src/store/index.js